export const iconFontAwesomeTransportationShip = (
	<i className="fa-solid fa-ship"></i>
);
